// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__B5NAQ","withTitle":"styles_withTitle__OIpYl","logo":"styles_logo__Qg59V","title":"styles_title__j9SOa"};